import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../grid/grid';
import '../typography/typography';
import css from './form-radio-button.css';
import FormCheckLabel from './form-check-label';

const FormRadioButton = ({ labelText, ...otherProps }) => (
  <div className={classnames(css['ds-form-radio-button'])}>
    <input type='radio' {...otherProps} />
    <div className={css['ds-form-radio-button__box']} />
    <FormCheckLabel isDisabled={otherProps.disabled} htmlFor={otherProps.id}>
      {labelText}
    </FormCheckLabel>
  </div>
);

FormRadioButton.defaultProps = {};

FormRadioButton.propTypes = {
  labelText: PropTypes.string.isRequired,
};

export default FormRadioButton;
